import React from "react";
import PropTypes from "prop-types";
import { Col } from "antd";
import { FormattedMessage } from "react-intl";

import CasparFormItem from "./CasparFormItem";
import InputTextField from "../../../Fields/InputTextField";

import { required } from "../../../../lib/utils/formValidation";

export default function CasparAudioFormItem({ prefix, disabled }) {
  return (
    <>
      <CasparFormItem prefix={prefix} disabled={disabled} />
      <Col span={15}>
        <InputTextField
          name={[...prefix, "casparAudioMatrix"]}
          disabled={disabled}
          label={<FormattedMessage id="CasparAudioFormItem.casparAudioMatrix" defaultMessage="Audio matrix" />}
          rules={[required]}
        />
      </Col>
    </>
  );
}

CasparAudioFormItem.propTypes = {
  prefix: PropTypes.arrayOf(PropTypes.string).isRequired,
  disabled: PropTypes.bool.isRequired,
};
